// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../rescript/lib/es6/list.js";
import * as $$Array from "../../../../../rescript/lib/es6/array.js";
import * as Js_dict from "../../../../../rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../../rescript/lib/es6/belt_Option.js";

function fold(lst, valueOpt, param) {
  var value = valueOpt !== undefined ? valueOpt : "";
  if (!lst) {
    return value;
  }
  var tail = lst.tl;
  var head = lst.hd;
  if (tail) {
    return head + ("&" + fold(tail, value, undefined));
  } else {
    return value + head;
  }
}

function create(urlParams) {
  var keys = $$Array.to_list(Object.keys(urlParams));
  if (List.length(keys) <= 0) {
    return ;
  }
  var lst = List.map((function (key) {
          return key + ("=" + Belt_Option.getWithDefault(Js_dict.get(urlParams, key), ""));
        }), keys);
  return fold(lst, undefined, undefined);
}

export {
  create ,
  
}
/* No side effect */
